import React, { useMemo, useReducer } from 'react'
import './app.scss'
import AppContext from './app/context'
import reducer from './app/context/reducer'
import NavbarContext from './app/navbar/context'
import { reducer as navbarReducer } from './app/navbar/context/reducer'
import AppRoutes from './routing/AppRoutes'

const App = () => {
  const [state, contextDispatch] = useReducer(reducer, {
    locationDesignConfig: null,
    locationConfig: null,
    organizations: [],
    selectedOrganization: null,
    goals: [],
    selectedGoal: null,
    amount: null,
    rules: [],
    vouchers: [],
    paymentInfo: null,
  })

  const contextValue = useMemo(
    () => ({ state, contextDispatch }),
    [state, contextDispatch]
  )

  const [navbarState, navbarContextDispatch] = useReducer(navbarReducer, {
    backPathname: '',
    closePathname: '',
    isBackButtonVisible: true,
    isCloseButtonVisible: true,
  })

  const navbarContextValue = useMemo(
    () => ({ navbarState, navbarContextDispatch }),
    [navbarState, navbarContextDispatch]
  )

  return (
    <>
      <AppContext.Provider
        value={{
          state: contextValue.state,
          contextDispatch: contextValue.contextDispatch,
        }}
      >
        <NavbarContext.Provider
          value={{
            state: navbarContextValue.navbarState,
            contextDispatch: navbarContextValue.navbarContextDispatch,
          }}
        >
          <AppRoutes />
        </NavbarContext.Provider>
      </AppContext.Provider>
    </>
  )
}

export default App
